import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\mykonya\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\AdPackagesTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\DealsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\FeaturedBusinesses.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\NewsletterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\app\\components\\TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\components\\CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\components\\Header.tsx");
;
import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\mykonya\\src\\components\\ui\\AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\mykonya\\src\\components\\ui\\AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\mykonya\\src\\components\\ui\\AppLogo.tsx");
